import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookHeart"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H6.75C5.23122 22 4 20.7688 4 19.25V4.75C4 3.23122 5.23122 2 6.75 2H20V22ZM7 17.5C6.17157 17.5 5.5 18.1716 5.5 19V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H18.5V17.5H7ZM15.251 9.66797C15.2508 7.92017 13.5026 6.87862 11.999 7.84961C10.4956 6.87912 8.74827 7.92034 8.74805 9.66797C8.74836 11.9856 11.9588 13.2644 11.999 13.2803C12.021 13.2716 15.2507 11.9923 15.251 9.66797Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookHeart;
